/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Canvas_A11yInputs */

const en_scene_canvas_a11y = /** @type {(inputs: Scene_Canvas_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-time 3D visualization of the building and its robot fleets`)
};

const fr_scene_canvas_a11y = /** @type {(inputs: Scene_Canvas_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualisation 3D temps réel du bâtiment et de ses flottes de robots`)
};

const ms_sg2_scene_canvas_a11y = /** @type {(inputs: Scene_Canvas_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualisasi 3D masa nyata bangunan dan armada robotnya`)
};

/**
* | output |
* | --- |
* | "Real-time 3D visualization of the building and its robot fleets" |
*
* @param {Scene_Canvas_A11yInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const scene_canvas_a11y = /** @type {((inputs?: Scene_Canvas_A11yInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Canvas_A11yInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scene_canvas_a11y(inputs)
	if (locale === "fr") return fr_scene_canvas_a11y(inputs)
	return ms_sg2_scene_canvas_a11y(inputs)
});